import { Link } from '@/components/LocalizedLink';
import { useLanguage } from '@/contexts/LanguageContext';
import type { WebsiteBlogPost } from '@/lib/contentService';
import { resolveLocalizedValue } from '@/lib/blogLocalization';
import { getBlogLogicalPath } from '@/lib/blogSlugs';

type RelatedInsightsBlockProps = {
  posts: WebsiteBlogPost[];
  title?: string;
};

const RelatedInsightsBlock = ({ posts, title }: RelatedInsightsBlockProps) => {
  const { lang } = useLanguage();

  if (!posts.length) return null;

  return (
    <section className="mt-16 border-t border-border pt-12">
      <h2 className="font-display text-3xl font-bold text-foreground mb-6">
        {title || (lang === 'tr' ? 'İlgili İçerikler' : 'Related Insights')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {posts.map((post) => {
          const postTitle = resolveLocalizedValue(post.title_i18n, post.title, lang);
          const postExcerpt = resolveLocalizedValue(post.excerpt_i18n, post.excerpt, lang);

          return (
            <Link key={post.id} to={getBlogLogicalPath(post, lang)} className="rounded-xl border border-border/70 p-5 bg-card/40 hover:bg-card transition-colors">
              <p className="font-body text-xs text-muted-foreground mb-2 uppercase tracking-[0.2em]">
                {resolveLocalizedValue(post.category_i18n, post.category, lang)}
              </p>
              <h3 className="font-display text-lg text-foreground mb-2 line-clamp-2">{postTitle}</h3>
              <p className="font-body text-sm text-muted-foreground line-clamp-3">{postExcerpt}</p>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default RelatedInsightsBlock;
